import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29a5f709"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "general" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Detalles de Usuario ")
], -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales ")
], -1))
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Nombre: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Rol: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Estatus: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("fieldset", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h6", null, [
              _hoisted_6,
              _createTextVNode(_toDisplayString(_ctx.currentUsuario.nombre), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.currentUsuario.email), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(_ctx.currentUsuario.role), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.currentUsuario.estatus), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}